// React
import { FunctionComponent } from "react";
// Library
import { Title } from "@fyrstain/hl7-front-library";
// Components
import VestaPage from "../../components/VestaPage/VestaPage";
//Translation
import i18n from "i18next";
import { toPublicUrl } from "../../services/PublicUrl";

const Home: FunctionComponent = () => {
    return (
        <VestaPage loading={false} needsLogin={false}>
            <>
                <div className='h-100 d-flex justify-content-center align-items-center flex-md-row flex-column gap-3'>
                    <div>
                        <img
                            className='home-image-icon'
                            alt="Home_image"
                            src={toPublicUrl("/assets/home.jpg")} />

                    </div>
                    <div>
                        <Title level={1} prefix={'Vesta'} content={i18n.t('title.home')} />
                    </div>

                </div>
            </>

        </VestaPage>
    );
};

export default Home;
